module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/show_more-98d6bb124c6dd00f3670310570b54478.svg";